export const categories = [
  {
    slug: 'sex-education',
    name: '性教育科普',
    description: '科学的性教育知识，帮助您建立健康的性观念与认知',
    icon: 'ri-book-open-line',
    color: 'primary',
    articleCount: 12,
  },
  {
    slug: 'online-safety',
    name: '网络安全防护',
    description: '学习如何保护个人信息，防范网络风险与诈骗',
    icon: 'ri-shield-check-line',
    color: 'secondary',
    articleCount: 10,
  },
  {
    slug: 'privacy-protection',
    name: '隐私保护指南',
    description: '了解隐私保护的重要性与实用方法，安全上网不泄露',
    icon: 'ri-lock-line',
    color: 'accent',
    articleCount: 8,
  },
  {
    slug: 'laws-and-regulations',
    name: '法律法规解读',
    description: '了解与成人内容相关的法律法规，做守法公民',
    icon: 'ri-scales-line',
    color: 'primary',
    articleCount: 7,
  },
  {
    slug: 'healthy-knowledge',
    name: '健康性知识',
    description: '权威的健康性知识科普，关爱身心健康',
    icon: 'ri-heart-pulse-line',
    color: 'secondary',
    articleCount: 15,
  },
  {
    slug: 'platform-recommend',
    name: '正规平台推荐',
    description: '推荐安全正规的内容平台，远离非法与不良信息',
    icon: 'ri-thumb-up-line',
    color: 'accent',
    articleCount: 6,
  },
];